/**
 * Whitelabel Default Configuration
 *
 * Default colors, images, and typography for branding system
 */

export const DEFAULT_COLORS = {
  '--bs-primary': '#69C7C1',
  '--bs-secondary': '#074F47',
  '--bs-secondary-rgba': 'rgba(7, 79, 71, 0.4)',
  '--bs-gray': '#6c757d',
  '--bs-gray-2': '#DDE2E5',
  '--bs-gray-400': '#ced4da',
  '--bs-gray-600': '#6c757d',
  '--bs-gray-stone': '#54595f',
  '--bs-light': '#f0f2f5',
  '--bs-calendar-highlight': '#F6F1EE',
  '--bs-black-button': '#000000',
  '--bs-coral': '#ff5757',
  '--bs-soft-coral': '#FBD3D1',
  '--bs-soft-mint': '#D5EEEB',
  '--bs-peach': '#FBCCAE',
  '--bs-light-teal-gray': '#B9C7C7',
  '--bs-sage-gray': '#718080',
  '--bs-warm-gray': '#DAD2D1',
  '--bs-off-white': '#F6F8F5',
};

export const DEFAULT_IMAGES = {
  // Logos
  logo_big: '/assets/branding/logos/logo-big.png',
  logo_small: '/assets/branding/logos/logo-small.png',
  logo_favicon: '/assets/branding/logos/favicon.png',

  // Dashboard (WebP for smaller size, PNG/JPG kept as fallback on disk)
  dashboard_header: '/assets/branding/headers/dashboard-header.webp',
  dashboard_footer: '/assets/branding/headers/dashboard-footer.webp',

  // Page Headers (WebP for smaller size)
  calendar_header: '/assets/branding/headers/calendar.webp',
  list_header: '/assets/branding/headers/list.webp',
  brandcheck_header: '/assets/branding/headers/brandcheck.webp',
  release_header: '/assets/branding/headers/release.webp',
  agencycc_header: '/assets/branding/headers/agencycc.webp',
  approval_header: '/assets/branding/headers/approval.webp',

  // Misc
  gif_loader: '/assets/branding/misc/loader.gif',
  placeholder: '/assets/branding/misc/placeholder.png',
  og_image: '/assets/branding/logos/logo-big.png',
  email_logo: '/assets/branding/logos/logo-small.png',

  // PWA
  pwa_icon_192: '/assets/branding/pwa/icon-192.png',
  pwa_icon_512: '/assets/branding/pwa/icon-512.png',
  pwa_splash: '/assets/branding/pwa/splash.png',
};

export const DEFAULT_FONT = {
  name: 'wagner',
  family: "'wagner', sans-serif",
};
